import axios, { AxiosResponse } from 'axios';
import createScraperUrl from 'lib/create-scraper-url';

export const createUploadRequest = (): Promise<
  AxiosResponse<{ publicUrl: string; uploadUrl: string }>
> => {
  return axios.post(createScraperUrl('/pdf-upload/signed-requests'));
};
